import React, { useState } from 'react';
import { signIn, signUp, confirmSignUp, signOut } from 'aws-amplify/auth';
import Button from './figma/Button';
import Input from './figma/Input';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [businessName, setBusinessName] = useState('');
  const [loading, setLoading] = useState(false);
  const [needsConfirmation, setNeedsConfirmation] = useState(false);
  const [confirmationCode, setConfirmationCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (needsConfirmation) {
        await confirmSignUp({ username: email, confirmationCode });
        setNeedsConfirmation(false);
        setIsSignUp(false);
        alert('Email confirmed! Please sign in.');
      } else if (isSignUp) {
        await signUp({
          username: email,
          password,
          options: {
            userAttributes: { email, given_name: businessName }
          }
        });
        setNeedsConfirmation(true);
      } else {
        // Clear any existing session first
        try {
          await signOut();
        } catch (e) {
          // Ignore if no session exists
        }
        const { isSignedIn } = await signIn({ username: email, password });
        if (isSignedIn) {
          onLogin({ email, token: 'cognito-token' });
        }
      }
    } catch (err) {
      setError(err.message);
      console.error('Auth error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-12 rounded-2xl shadow-xl w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {needsConfirmation ? 'Confirm Email' : (isSignUp ? 'Partner Registration' : 'Partner Portal')}
          </h1>
          <p className="text-gray-600">
            Remote Assistant Partner Program
          </p>
        </div>
        
        {error && (
          <div className="bg-red-100 text-red-600 p-4 rounded-xl mb-4 text-center">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          {needsConfirmation ? (
            <Input
              type="text"
              required
              value={confirmationCode}
              onChange={(e) => setConfirmationCode(e.target.value)}
              placeholder="Confirmation Code"
            />
          ) : (
            <>
              {isSignUp && (
                <Input
                  type="text"
                  required
                  value={businessName}
                  onChange={(e) => setBusinessName(e.target.value)}
                  placeholder="Business Name"
                />
              )}
              
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
              />
              
              <Input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
              />
            </>
          )}

          <Button
            type="submit"
            disabled={loading}
            variant="primary"
            fullWidth
          >
            {loading ? 'Processing...' : (needsConfirmation ? 'Confirm' : (isSignUp ? 'Create Account' : 'Sign In'))}
          </Button>

          {!needsConfirmation && (
            <div className="text-center mt-4">
              <button
                type="button"
                onClick={() => setIsSignUp(!isSignUp)}
                className="text-blue-500 hover:text-blue-600 font-semibold"
              >
                {isSignUp ? 'Already have an account? Sign in' : 'Need an account? Sign up'}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default Login;